import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useInvoiceRemarksList() {

    //User toast
    const toast = useToast()

    const refInvoiceRemarkListTable = ref(null)

    const tableColumns = [
        {key: 'name', label:'名稱', sortable: true},
        {key: 'remark', label: '銷售備註'},
        {key: 'action', label: '操作'}
    ]

    const perPage = ref(10)
    const totalInvoiceRemarks = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(false)

    const dataMeta = computed(() => {
        const localItemsCount = refInvoiceRemarkListTable.value ? refInvoiceRemarkListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalInvoiceRemarks.value,
        }
    })

    const refetchData = () => {
        refInvoiceRemarkListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchInvoiceRemarks = (ctx, callback) => {
        store.dispatch('setting-invoiceremark/fetchInvoiceRemarks',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {invoice_remarks, total} = response.data
            callback(invoice_remarks)
            totalInvoiceRemarks.value = total
        
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching invoice methods list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchInvoiceRemarks,
        tableColumns,
        perPage,
        currentPage,
        totalInvoiceRemarks,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refInvoiceRemarkListTable,
        ability,
        refetchData
    }

}